import React, { useState } from 'react';
import { Box, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ContestFormDialogLayout, FormFooterButtons } from './ContestFormDialogLayout';

interface TeamFormProps {
  onSave: (data: { name: string }) => void;
  onCancel: () => void;
}

export const TeamForm = ({ onSave, onCancel }: TeamFormProps) => {
  const { t } = useTranslation('contests');
  const [form, setForm] = useState({
    name: ''
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (form.name.trim()) {
      onSave(form);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <ContestFormDialogLayout
        title={t('teamForm.title')}
        subtitle={t('teamForm.subtitle')}
        onClose={onCancel}
        footer={<FormFooterButtons onCancel={onCancel} submitLabel={t('teamForm.title')} submitDisabled={!form.name.trim()} />}
      >
        <TextField
          fullWidth
          label={t('teamForm.name')}
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
          required
          autoFocus
          placeholder={t('teamForm.namePlaceholder')}
        />
      </ContestFormDialogLayout>
    </Box>
  );
};
